import { tv } from 'tailwind-variants';

export const defaultVariants = tv({
  slots: {
    base: ['relative', 'w-full'],
    desktopWrapper: [
      'hidden md:block',
      'relative',
      'w-full',
      'min-h-[500px]',
      // backwards fill-mode holds the 0% (opacity:0) keyframe until the animation engages,
      // preventing a one-frame flash of the fully-visible slide on mount
      'animate-[fadeInFromNone_0.5s_ease-in-out_backwards]',
    ],
    imageContainer: ['absolute inset-0', 'w-full h-full'],
    image: ['w-full h-full', 'object-cover'],
    contentOverlay: ['flex flex-col justify-between'],
    textContent: ['absolute top-[70px] left-[80px]', 'max-w-[620px]', 'text-white'],
    eyebrow: ['text-xl font-semibold leading-6', 'mb-5'],
    headline: [
      '[&_h3]:font-black! [&_h3]:text-[50px]! [&_h3]:leading-[50px]!',
      '[&_h3]:text-white!',
      '[&_a]:underline [&_a]:text-[80%] [&_a]:underline-offset-[-0.3em] [&_a]:top-[-0.2em] [&_a]:relative [&_a]:leading-0 [&_a]:inline [&_a]:p-0',
      '[&_a]:hover:no-underline',
      'mb-5',
    ],
    bodyCopy: ['mt-4', 'text-base md:text-lg', '[&_p]:text-white'],
    ctaWrapper: ['inline-block', 'mt-4'],
    tabsContainer: [
      'relative',
      'flex gap-1',
      'w-full max-w-[83.3333%]',
      'mx-auto -mt-10.5',
      'bg-white',
    ],
  },
});

export const tabVariants = tv({
  slots: {
    tabButton: [
      'flex-1',
      'flex flex-col items-start justify-start',
      'p-4',
      'cursor-pointer',
      'transition-colors duration-200',
      'text-left',
    ],
    tabNumber: ['text-base font-medium leading-6', 'mb-1'],
    tabTitle: ['text-base font-medium leading-6'],
  },
  variants: {
    isActive: {
      true: {
        tabButton: ['bg-primary', 'text-white'],
        tabNumber: ['text-white'],
        tabTitle: ['text-white'],
      },
      false: {
        tabButton: ['bg-light-gray', 'hover:bg-medium-gray'],
        tabNumber: ['text-textPrimary'],
        tabTitle: ['text-textPrimary'],
      },
    },
  },
  defaultVariants: {
    isActive: false,
  },
});

export const accordionVariants = tv({
  slots: {
    mobileWrapper: ['w-full', 'px-6'],
    subtitle: [
      'md:hidden',
      'text-[27.2px]! font-bold! leading-[32.63333px]',
      'text-center',
      'text-primary',
      'mb-6 px-4',
    ],
    accordionList: ['w-full', 'flex flex-col', 'gap-2'],
    accordionItem: ['w-full'],
    accordionHeader: [
      'w-full',
      'flex items-center justify-between',
      'px-4 py-4',
      'cursor-pointer',
      'transition-colors duration-200',
    ],
    accordionTitle: ['text-[19.2px] font-semibold leading-[28.8px]', 'text-left'],
    accordionIcon: ['fa-solid fa-chevron-down', 'text-xl', 'transition-transform duration-200'],
    accordionContent: ['grid', 'transition-[grid-template-rows] duration-300 ease-in-out'],
    accordionInner: ['overflow-hidden min-h-0'],
    imageWrapper: ['relative', 'w-full', 'aspect-[2/1]'],
    mobileImage: ['w-full h-full', 'object-cover'],
    mobileTextContent: ['px-[25px] pt-[25px] pb-4', 'border border-light-gray border-t-0'],
    mobileEyebrow: ['hidden'],
    mobileHeadline: [
      '[&_h3]:text-[26px]! [&_h3]:font-black! [&_h3]:leading-[31.2px]!',
      '[&_a]:underline [&_a]:text-[80%] [&_a]:underline-offset-[-0.3em] [&_a]:top-[-0.2em] [&_a]:relative [&_a]:leading-0 [&_a]:inline [&_a]:p-0',
      '[&_a]:hover:no-underline',
      'text-primary [&_h3]:text-primary!',
      'leading-tight',
    ],
    mobileBodyCopy: ['mt-3', 'text-sm', '[&_p]:text-gray-700'],
    mobileCtaWrapper: ['inline-block', 'mt-4 md:mb-7'],
  },
  variants: {
    isOpen: {
      true: {
        accordionHeader: ['bg-primary', 'text-white'],
        accordionTitle: ['text-white'],
        accordionIcon: ['text-white', 'rotate-180'],
        accordionContent: ['grid-rows-[1fr]'],
        accordionInner: ['visible'],
      },
      false: {
        accordionHeader: ['bg-light-gray', 'text-textPrimary'],
        accordionTitle: ['text-textPrimary'],
        accordionIcon: ['text-textPrimary'],
        accordionContent: ['grid-rows-[0fr]'],
        accordionInner: ['invisible'],
      },
    },
  },
  defaultVariants: {
    isOpen: false,
  },
});
